import React from "react";

import Box from "../../components/Box";
import Menu from "../../components/Menu";
import Text from "../../components/Text";
import Page from "../../components/Page";
import Link from "../../components/Link";
import Flex from "../../components/Flex";
import Wrapper from "../../components/Wrapper";

function Privacy() {
  const Paragraph = ({ children }) => {
    return (
      <Text
        pb={4}
        fontSize={[2, 3, 3, 3]}
        color="black"
        fontWeight="400"
        lineHeight={1.4}
        maxWidth={800}
        marginLeft="auto"
        marginRight="auto"
      >
        {children}
      </Text>
    );
  };
  return (
    <Page
      metaData={{
        title: "Privacy"
      }}
    >
      <Box bg="green">
        <Menu />
        <Wrapper px={4}>
          <Flex flexDirection="column" mt={5}>
            <Box>
              <Text
                pb={3}
                letterSpacing={-2}
                fontSize={[5, 6, 7, 7]}
                color="white"
                fontFamily="gt"
                fontWeight="bold"
                lineHeight={1.1}
                maxWidth={800}
                marginLeft="auto"
                marginRight="auto"
                as="h1"
              >
                Privacy
              </Text>
            </Box>
          </Flex>
        </Wrapper>
      </Box>
      <Wrapper px={4} py={5}>
        <Paragraph>
          Your privacy is important to us. It is Greenlist's policy to respect
          your privacy regarding any information we may collect from you across
          our website,{" "}
          <Link href="https://greenlistapp.com">greenlistapp.com</Link>, and
          other sites we own and operate.
        </Paragraph>

        <Paragraph>
          We only ask for personal information when we truly need it to provide
          a service to you. We collect it by fair and lawful means, with your
          knowledge and consent. We also let you know why we’re collecting it
          and how it will be used.
        </Paragraph>
        <Paragraph>
          We only retain collected information for as long as necessary to
          provide you with your requested service. What data we store, we’ll
          protect within commercially acceptable means to prevent loss and
          theft, as well as unauthorised access, disclosure, copying, use or
          modification.
        </Paragraph>
        <Paragraph>
          We don’t share any personally identifying information publicly or with
          third-parties, except when required to by law.
        </Paragraph>
        <Paragraph>
          Our website may link to external sites that are not operated by us.
          Please be aware that we have no control over the content and practices
          of these sites, and cannot accept responsibility or liability for
          their respective privacy policies.
        </Paragraph>
        <Paragraph>
          You are free to refuse any request we may make for your personal
          information, with the understanding that we may be unable to provide
          you with some of your desired services. Please contact us if you would
          like your personal information removed.
        </Paragraph>

        <Paragraph>
          Your continued use of our website will be regarded as acceptance of
          our practices around privacy and personal information. If you have any
          questions about how we handle user data and personal information, feel
          free to contact us.
        </Paragraph>
        <Paragraph>This policy is effective as of 11 Sep 2020.</Paragraph>
      </Wrapper>
    </Page>
  );
}

export default Privacy;
